import { setTerm } from './helpers';

export const setWithLayout = setTerm('with_layout');
